export default __webpack_public_path__ + "static/cta-busy-2-c58204f7ff7cd0c7d987fb465dafe9dd.jpg";